import { PreviewCard } from '@aibees/elephant/components/backoffice/preview-card';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(PreviewCard)``;

export const Container = styled(Stack)`
  background: rgb(255, 255, 255);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(0, 0, 0, 0.1545211834733894) 100%
  );
  width: ${(p) => p.theme.spacing(9)};
  height: ${(p) => p.theme.spacing(9)};
  border-radius: 50%;
`;

export const Logo = styled('img')`
  width: ${(p) => p.theme.spacing(3.5)};
  margin: auto;
`;
